import type { ArtifactListItem } from '@/types/artifacts';

export function useArtifactRole(artifact: ArtifactListItem | null) {
  const canRename =
    artifact?.user_role === 'artifact:editor' ||
    artifact?.user_role === 'artifact:owner';

  const canShare =
    artifact?.user_role === 'artifact:editor' ||
    artifact?.user_role === 'artifact:owner';

  const canDelete = artifact?.user_role === 'artifact:owner';

  return { canRename, canShare, canDelete };
}
